// source: codingAssistant.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

goog.exportSymbol('proto.codingAssistant.CloseSessionRequest', null, global);
goog.exportSymbol('proto.codingAssistant.ConversationInfo', null, global);
goog.exportSymbol('proto.codingAssistant.ConversationListResponse', null, global);
goog.exportSymbol('proto.codingAssistant.CreateSessionRequest', null, global);
goog.exportSymbol('proto.codingAssistant.DeleteConversationRequest', null, global);
goog.exportSymbol('proto.codingAssistant.ErrorResponse', null, global);
goog.exportSymbol('proto.codingAssistant.ListConversationsRequest', null, global);
goog.exportSymbol('proto.codingAssistant.SendMessageRequest', null, global);
goog.exportSymbol('proto.codingAssistant.SessionCreatedResponse', null, global);
goog.exportSymbol('proto.codingAssistant.StreamChunkResponse', null, global);
goog.exportSymbol('proto.codingAssistant.StreamCompleteResponse', null, global);
goog.exportSymbol('proto.codingAssistant.ToCodeAssistClient', null, global);
goog.exportSymbol('proto.codingAssistant.ToCodeAssistClient.TypeCase', null, global);
goog.exportSymbol('proto.codingAssistant.ToCodeAssistServer', null, global);
goog.exportSymbol('proto.codingAssistant.ToCodeAssistServer.ContentCase', null, global);
goog.exportSymbol('proto.codingAssistant.ValidationError', null, global);
goog.exportSymbol('proto.codingAssistant.ValidationResult', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.codingAssistant.ToCodeAssistServer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.codingAssistant.ToCodeAssistServer.oneofGroups_);
};
goog.inherits(proto.codingAssistant.ToCodeAssistServer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.codingAssistant.ToCodeAssistServer.displayName = 'proto.codingAssistant.ToCodeAssistServer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.codingAssistant.ToCodeAssistClient = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.codingAssistant.ToCodeAssistClient.oneofGroups_);
};
goog.inherits(proto.codingAssistant.ToCodeAssistClient, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.codingAssistant.ToCodeAssistClient.displayName = 'proto.codingAssistant.ToCodeAssistClient';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.codingAssistant.CreateSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.codingAssistant.CreateSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.codingAssistant.CreateSessionRequest.displayName = 'proto.codingAssistant.CreateSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.codingAssistant.SessionCreatedResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.codingAssistant.SessionCreatedResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.codingAssistant.SessionCreatedResponse.displayName = 'proto.codingAssistant.SessionCreatedResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.codingAssistant.CloseSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.codingAssistant.CloseSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.codingAssistant.CloseSessionRequest.displayName = 'proto.codingAssistant.CloseSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.codingAssistant.SendMessageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.codingAssistant.SendMessageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.codingAssistant.SendMessageRequest.displayName = 'proto.codingAssistant.SendMessageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.codingAssistant.StreamChunkResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.codingAssistant.StreamChunkResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.codingAssistant.StreamChunkResponse.displayName = 'proto.codingAssistant.StreamChunkResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.codingAssistant.StreamCompleteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.codingAssistant.StreamCompleteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.codingAssistant.StreamCompleteResponse.displayName = 'proto.codingAssistant.StreamCompleteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.codingAssistant.ErrorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.codingAssistant.ErrorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.codingAssistant.ErrorResponse.displayName = 'proto.codingAssistant.ErrorResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.codingAssistant.ValidationResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.codingAssistant.ValidationResult.repeatedFields_, null);
};
goog.inherits(proto.codingAssistant.ValidationResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.codingAssistant.ValidationResult.displayName = 'proto.codingAssistant.ValidationResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.codingAssistant.ValidationError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.codingAssistant.ValidationError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.codingAssistant.ValidationError.displayName = 'proto.codingAssistant.ValidationError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.codingAssistant.ListConversationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.codingAssistant.ListConversationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.codingAssistant.ListConversationsRequest.displayName = 'proto.codingAssistant.ListConversationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.codingAssistant.ConversationListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.codingAssistant.ConversationListResponse.repeatedFields_, null);
};
goog.inherits(proto.codingAssistant.ConversationListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.codingAssistant.ConversationListResponse.displayName = 'proto.codingAssistant.ConversationListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.codingAssistant.ConversationInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.codingAssistant.ConversationInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.codingAssistant.ConversationInfo.displayName = 'proto.codingAssistant.ConversationInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.codingAssistant.DeleteConversationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.codingAssistant.DeleteConversationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.codingAssistant.DeleteConversationRequest.displayName = 'proto.codingAssistant.DeleteConversationRequest';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.codingAssistant.ToCodeAssistServer.oneofGroups_ = [[1,2,3,4,5]];

/**
 * @enum {number}
 */
proto.codingAssistant.ToCodeAssistServer.ContentCase = {
  CONTENT_NOT_SET: 0,
  CREATE_SESSION: 1,
  SEND_MESSAGE: 2,
  CLOSE_SESSION: 3,
  LIST_CONVERSATIONS: 4,
  DELETE_CONVERSATION: 5
};

/**
 * @return {proto.codingAssistant.ToCodeAssistServer.ContentCase}
 */
proto.codingAssistant.ToCodeAssistServer.prototype.getContentCase = function() {
  return /** @type {proto.codingAssistant.ToCodeAssistServer.ContentCase} */(jspb.Message.computeOneofCase(this, proto.codingAssistant.ToCodeAssistServer.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.codingAssistant.ToCodeAssistServer.prototype.toObject = function(opt_includeInstance) {
  return proto.codingAssistant.ToCodeAssistServer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.codingAssistant.ToCodeAssistServer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ToCodeAssistServer.toObject = function(includeInstance, msg) {
  var f, obj = {
    createSession: (f = msg.getCreateSession()) && proto.codingAssistant.CreateSessionRequest.toObject(includeInstance, f),
    sendMessage: (f = msg.getSendMessage()) && proto.codingAssistant.SendMessageRequest.toObject(includeInstance, f),
    closeSession: (f = msg.getCloseSession()) && proto.codingAssistant.CloseSessionRequest.toObject(includeInstance, f),
    listConversations: (f = msg.getListConversations()) && proto.codingAssistant.ListConversationsRequest.toObject(includeInstance, f),
    deleteConversation: (f = msg.getDeleteConversation()) && proto.codingAssistant.DeleteConversationRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.codingAssistant.ToCodeAssistServer}
 */
proto.codingAssistant.ToCodeAssistServer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.codingAssistant.ToCodeAssistServer;
  return proto.codingAssistant.ToCodeAssistServer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.codingAssistant.ToCodeAssistServer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.codingAssistant.ToCodeAssistServer}
 */
proto.codingAssistant.ToCodeAssistServer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.codingAssistant.CreateSessionRequest;
      reader.readMessage(value,proto.codingAssistant.CreateSessionRequest.deserializeBinaryFromReader);
      msg.setCreateSession(value);
      break;
    case 2:
      var value = new proto.codingAssistant.SendMessageRequest;
      reader.readMessage(value,proto.codingAssistant.SendMessageRequest.deserializeBinaryFromReader);
      msg.setSendMessage(value);
      break;
    case 3:
      var value = new proto.codingAssistant.CloseSessionRequest;
      reader.readMessage(value,proto.codingAssistant.CloseSessionRequest.deserializeBinaryFromReader);
      msg.setCloseSession(value);
      break;
    case 4:
      var value = new proto.codingAssistant.ListConversationsRequest;
      reader.readMessage(value,proto.codingAssistant.ListConversationsRequest.deserializeBinaryFromReader);
      msg.setListConversations(value);
      break;
    case 5:
      var value = new proto.codingAssistant.DeleteConversationRequest;
      reader.readMessage(value,proto.codingAssistant.DeleteConversationRequest.deserializeBinaryFromReader);
      msg.setDeleteConversation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.codingAssistant.ToCodeAssistServer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.codingAssistant.ToCodeAssistServer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.codingAssistant.ToCodeAssistServer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ToCodeAssistServer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreateSession();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.codingAssistant.CreateSessionRequest.serializeBinaryToWriter
    );
  }
  f = message.getSendMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.codingAssistant.SendMessageRequest.serializeBinaryToWriter
    );
  }
  f = message.getCloseSession();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.codingAssistant.CloseSessionRequest.serializeBinaryToWriter
    );
  }
  f = message.getListConversations();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.codingAssistant.ListConversationsRequest.serializeBinaryToWriter
    );
  }
  f = message.getDeleteConversation();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.codingAssistant.DeleteConversationRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional CreateSessionRequest create_session = 1;
 * @return {?proto.codingAssistant.CreateSessionRequest}
 */
proto.codingAssistant.ToCodeAssistServer.prototype.getCreateSession = function() {
  return /** @type{?proto.codingAssistant.CreateSessionRequest} */ (
    jspb.Message.getWrapperField(this, proto.codingAssistant.CreateSessionRequest, 1));
};


/**
 * @param {?proto.codingAssistant.CreateSessionRequest|undefined} value
 * @return {!proto.codingAssistant.ToCodeAssistServer} returns this
*/
proto.codingAssistant.ToCodeAssistServer.prototype.setCreateSession = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.codingAssistant.ToCodeAssistServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.codingAssistant.ToCodeAssistServer} returns this
 */
proto.codingAssistant.ToCodeAssistServer.prototype.clearCreateSession = function() {
  return this.setCreateSession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.codingAssistant.ToCodeAssistServer.prototype.hasCreateSession = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SendMessageRequest send_message = 2;
 * @return {?proto.codingAssistant.SendMessageRequest}
 */
proto.codingAssistant.ToCodeAssistServer.prototype.getSendMessage = function() {
  return /** @type{?proto.codingAssistant.SendMessageRequest} */ (
    jspb.Message.getWrapperField(this, proto.codingAssistant.SendMessageRequest, 2));
};


/**
 * @param {?proto.codingAssistant.SendMessageRequest|undefined} value
 * @return {!proto.codingAssistant.ToCodeAssistServer} returns this
*/
proto.codingAssistant.ToCodeAssistServer.prototype.setSendMessage = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.codingAssistant.ToCodeAssistServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.codingAssistant.ToCodeAssistServer} returns this
 */
proto.codingAssistant.ToCodeAssistServer.prototype.clearSendMessage = function() {
  return this.setSendMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.codingAssistant.ToCodeAssistServer.prototype.hasSendMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CloseSessionRequest close_session = 3;
 * @return {?proto.codingAssistant.CloseSessionRequest}
 */
proto.codingAssistant.ToCodeAssistServer.prototype.getCloseSession = function() {
  return /** @type{?proto.codingAssistant.CloseSessionRequest} */ (
    jspb.Message.getWrapperField(this, proto.codingAssistant.CloseSessionRequest, 3));
};


/**
 * @param {?proto.codingAssistant.CloseSessionRequest|undefined} value
 * @return {!proto.codingAssistant.ToCodeAssistServer} returns this
*/
proto.codingAssistant.ToCodeAssistServer.prototype.setCloseSession = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.codingAssistant.ToCodeAssistServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.codingAssistant.ToCodeAssistServer} returns this
 */
proto.codingAssistant.ToCodeAssistServer.prototype.clearCloseSession = function() {
  return this.setCloseSession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.codingAssistant.ToCodeAssistServer.prototype.hasCloseSession = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ListConversationsRequest list_conversations = 4;
 * @return {?proto.codingAssistant.ListConversationsRequest}
 */
proto.codingAssistant.ToCodeAssistServer.prototype.getListConversations = function() {
  return /** @type{?proto.codingAssistant.ListConversationsRequest} */ (
    jspb.Message.getWrapperField(this, proto.codingAssistant.ListConversationsRequest, 4));
};


/**
 * @param {?proto.codingAssistant.ListConversationsRequest|undefined} value
 * @return {!proto.codingAssistant.ToCodeAssistServer} returns this
*/
proto.codingAssistant.ToCodeAssistServer.prototype.setListConversations = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.codingAssistant.ToCodeAssistServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.codingAssistant.ToCodeAssistServer} returns this
 */
proto.codingAssistant.ToCodeAssistServer.prototype.clearListConversations = function() {
  return this.setListConversations(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.codingAssistant.ToCodeAssistServer.prototype.hasListConversations = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional DeleteConversationRequest delete_conversation = 5;
 * @return {?proto.codingAssistant.DeleteConversationRequest}
 */
proto.codingAssistant.ToCodeAssistServer.prototype.getDeleteConversation = function() {
  return /** @type{?proto.codingAssistant.DeleteConversationRequest} */ (
    jspb.Message.getWrapperField(this, proto.codingAssistant.DeleteConversationRequest, 5));
};


/**
 * @param {?proto.codingAssistant.DeleteConversationRequest|undefined} value
 * @return {!proto.codingAssistant.ToCodeAssistServer} returns this
*/
proto.codingAssistant.ToCodeAssistServer.prototype.setDeleteConversation = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.codingAssistant.ToCodeAssistServer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.codingAssistant.ToCodeAssistServer} returns this
 */
proto.codingAssistant.ToCodeAssistServer.prototype.clearDeleteConversation = function() {
  return this.setDeleteConversation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.codingAssistant.ToCodeAssistServer.prototype.hasDeleteConversation = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.codingAssistant.ToCodeAssistClient.oneofGroups_ = [[1,2,3,4,5]];

/**
 * @enum {number}
 */
proto.codingAssistant.ToCodeAssistClient.TypeCase = {
  TYPE_NOT_SET: 0,
  SESSION_CREATED: 1,
  STREAM_CHUNK: 2,
  STREAM_COMPLETE: 3,
  ERROR: 4,
  CONVERSATION_LIST: 5
};

/**
 * @return {proto.codingAssistant.ToCodeAssistClient.TypeCase}
 */
proto.codingAssistant.ToCodeAssistClient.prototype.getTypeCase = function() {
  return /** @type {proto.codingAssistant.ToCodeAssistClient.TypeCase} */(jspb.Message.computeOneofCase(this, proto.codingAssistant.ToCodeAssistClient.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.codingAssistant.ToCodeAssistClient.prototype.toObject = function(opt_includeInstance) {
  return proto.codingAssistant.ToCodeAssistClient.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.codingAssistant.ToCodeAssistClient} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ToCodeAssistClient.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionCreated: (f = msg.getSessionCreated()) && proto.codingAssistant.SessionCreatedResponse.toObject(includeInstance, f),
    streamChunk: (f = msg.getStreamChunk()) && proto.codingAssistant.StreamChunkResponse.toObject(includeInstance, f),
    streamComplete: (f = msg.getStreamComplete()) && proto.codingAssistant.StreamCompleteResponse.toObject(includeInstance, f),
    error: (f = msg.getError()) && proto.codingAssistant.ErrorResponse.toObject(includeInstance, f),
    conversationList: (f = msg.getConversationList()) && proto.codingAssistant.ConversationListResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.codingAssistant.ToCodeAssistClient}
 */
proto.codingAssistant.ToCodeAssistClient.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.codingAssistant.ToCodeAssistClient;
  return proto.codingAssistant.ToCodeAssistClient.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.codingAssistant.ToCodeAssistClient} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.codingAssistant.ToCodeAssistClient}
 */
proto.codingAssistant.ToCodeAssistClient.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.codingAssistant.SessionCreatedResponse;
      reader.readMessage(value,proto.codingAssistant.SessionCreatedResponse.deserializeBinaryFromReader);
      msg.setSessionCreated(value);
      break;
    case 2:
      var value = new proto.codingAssistant.StreamChunkResponse;
      reader.readMessage(value,proto.codingAssistant.StreamChunkResponse.deserializeBinaryFromReader);
      msg.setStreamChunk(value);
      break;
    case 3:
      var value = new proto.codingAssistant.StreamCompleteResponse;
      reader.readMessage(value,proto.codingAssistant.StreamCompleteResponse.deserializeBinaryFromReader);
      msg.setStreamComplete(value);
      break;
    case 4:
      var value = new proto.codingAssistant.ErrorResponse;
      reader.readMessage(value,proto.codingAssistant.ErrorResponse.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 5:
      var value = new proto.codingAssistant.ConversationListResponse;
      reader.readMessage(value,proto.codingAssistant.ConversationListResponse.deserializeBinaryFromReader);
      msg.setConversationList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.codingAssistant.ToCodeAssistClient.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.codingAssistant.ToCodeAssistClient.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.codingAssistant.ToCodeAssistClient} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ToCodeAssistClient.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionCreated();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.codingAssistant.SessionCreatedResponse.serializeBinaryToWriter
    );
  }
  f = message.getStreamChunk();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.codingAssistant.StreamChunkResponse.serializeBinaryToWriter
    );
  }
  f = message.getStreamComplete();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.codingAssistant.StreamCompleteResponse.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.codingAssistant.ErrorResponse.serializeBinaryToWriter
    );
  }
  f = message.getConversationList();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.codingAssistant.ConversationListResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional SessionCreatedResponse session_created = 1;
 * @return {?proto.codingAssistant.SessionCreatedResponse}
 */
proto.codingAssistant.ToCodeAssistClient.prototype.getSessionCreated = function() {
  return /** @type{?proto.codingAssistant.SessionCreatedResponse} */ (
    jspb.Message.getWrapperField(this, proto.codingAssistant.SessionCreatedResponse, 1));
};


/**
 * @param {?proto.codingAssistant.SessionCreatedResponse|undefined} value
 * @return {!proto.codingAssistant.ToCodeAssistClient} returns this
*/
proto.codingAssistant.ToCodeAssistClient.prototype.setSessionCreated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.codingAssistant.ToCodeAssistClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.codingAssistant.ToCodeAssistClient} returns this
 */
proto.codingAssistant.ToCodeAssistClient.prototype.clearSessionCreated = function() {
  return this.setSessionCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.codingAssistant.ToCodeAssistClient.prototype.hasSessionCreated = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional StreamChunkResponse stream_chunk = 2;
 * @return {?proto.codingAssistant.StreamChunkResponse}
 */
proto.codingAssistant.ToCodeAssistClient.prototype.getStreamChunk = function() {
  return /** @type{?proto.codingAssistant.StreamChunkResponse} */ (
    jspb.Message.getWrapperField(this, proto.codingAssistant.StreamChunkResponse, 2));
};


/**
 * @param {?proto.codingAssistant.StreamChunkResponse|undefined} value
 * @return {!proto.codingAssistant.ToCodeAssistClient} returns this
*/
proto.codingAssistant.ToCodeAssistClient.prototype.setStreamChunk = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.codingAssistant.ToCodeAssistClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.codingAssistant.ToCodeAssistClient} returns this
 */
proto.codingAssistant.ToCodeAssistClient.prototype.clearStreamChunk = function() {
  return this.setStreamChunk(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.codingAssistant.ToCodeAssistClient.prototype.hasStreamChunk = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional StreamCompleteResponse stream_complete = 3;
 * @return {?proto.codingAssistant.StreamCompleteResponse}
 */
proto.codingAssistant.ToCodeAssistClient.prototype.getStreamComplete = function() {
  return /** @type{?proto.codingAssistant.StreamCompleteResponse} */ (
    jspb.Message.getWrapperField(this, proto.codingAssistant.StreamCompleteResponse, 3));
};


/**
 * @param {?proto.codingAssistant.StreamCompleteResponse|undefined} value
 * @return {!proto.codingAssistant.ToCodeAssistClient} returns this
*/
proto.codingAssistant.ToCodeAssistClient.prototype.setStreamComplete = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.codingAssistant.ToCodeAssistClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.codingAssistant.ToCodeAssistClient} returns this
 */
proto.codingAssistant.ToCodeAssistClient.prototype.clearStreamComplete = function() {
  return this.setStreamComplete(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.codingAssistant.ToCodeAssistClient.prototype.hasStreamComplete = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ErrorResponse error = 4;
 * @return {?proto.codingAssistant.ErrorResponse}
 */
proto.codingAssistant.ToCodeAssistClient.prototype.getError = function() {
  return /** @type{?proto.codingAssistant.ErrorResponse} */ (
    jspb.Message.getWrapperField(this, proto.codingAssistant.ErrorResponse, 4));
};


/**
 * @param {?proto.codingAssistant.ErrorResponse|undefined} value
 * @return {!proto.codingAssistant.ToCodeAssistClient} returns this
*/
proto.codingAssistant.ToCodeAssistClient.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.codingAssistant.ToCodeAssistClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.codingAssistant.ToCodeAssistClient} returns this
 */
proto.codingAssistant.ToCodeAssistClient.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.codingAssistant.ToCodeAssistClient.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ConversationListResponse conversation_list = 5;
 * @return {?proto.codingAssistant.ConversationListResponse}
 */
proto.codingAssistant.ToCodeAssistClient.prototype.getConversationList = function() {
  return /** @type{?proto.codingAssistant.ConversationListResponse} */ (
    jspb.Message.getWrapperField(this, proto.codingAssistant.ConversationListResponse, 5));
};


/**
 * @param {?proto.codingAssistant.ConversationListResponse|undefined} value
 * @return {!proto.codingAssistant.ToCodeAssistClient} returns this
*/
proto.codingAssistant.ToCodeAssistClient.prototype.setConversationList = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.codingAssistant.ToCodeAssistClient.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.codingAssistant.ToCodeAssistClient} returns this
 */
proto.codingAssistant.ToCodeAssistClient.prototype.clearConversationList = function() {
  return this.setConversationList(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.codingAssistant.ToCodeAssistClient.prototype.hasConversationList = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.codingAssistant.CreateSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.codingAssistant.CreateSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.codingAssistant.CreateSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.CreateSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contextType: jspb.Message.getFieldWithDefault(msg, 2, ""),
    projectId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    conversationId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.codingAssistant.CreateSessionRequest}
 */
proto.codingAssistant.CreateSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.codingAssistant.CreateSessionRequest;
  return proto.codingAssistant.CreateSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.codingAssistant.CreateSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.codingAssistant.CreateSessionRequest}
 */
proto.codingAssistant.CreateSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContextType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setConversationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.codingAssistant.CreateSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.codingAssistant.CreateSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.codingAssistant.CreateSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.CreateSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContextType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getConversationId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.codingAssistant.CreateSessionRequest.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.CreateSessionRequest} returns this
 */
proto.codingAssistant.CreateSessionRequest.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string context_type = 2;
 * @return {string}
 */
proto.codingAssistant.CreateSessionRequest.prototype.getContextType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.CreateSessionRequest} returns this
 */
proto.codingAssistant.CreateSessionRequest.prototype.setContextType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string project_id = 3;
 * @return {string}
 */
proto.codingAssistant.CreateSessionRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.CreateSessionRequest} returns this
 */
proto.codingAssistant.CreateSessionRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string conversation_id = 4;
 * @return {string}
 */
proto.codingAssistant.CreateSessionRequest.prototype.getConversationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.CreateSessionRequest} returns this
 */
proto.codingAssistant.CreateSessionRequest.prototype.setConversationId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.codingAssistant.SessionCreatedResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.codingAssistant.SessionCreatedResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.codingAssistant.SessionCreatedResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.SessionCreatedResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    conversationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    error: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.codingAssistant.SessionCreatedResponse}
 */
proto.codingAssistant.SessionCreatedResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.codingAssistant.SessionCreatedResponse;
  return proto.codingAssistant.SessionCreatedResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.codingAssistant.SessionCreatedResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.codingAssistant.SessionCreatedResponse}
 */
proto.codingAssistant.SessionCreatedResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConversationId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.codingAssistant.SessionCreatedResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.codingAssistant.SessionCreatedResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.codingAssistant.SessionCreatedResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.SessionCreatedResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConversationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.codingAssistant.SessionCreatedResponse.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.SessionCreatedResponse} returns this
 */
proto.codingAssistant.SessionCreatedResponse.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string conversation_id = 2;
 * @return {string}
 */
proto.codingAssistant.SessionCreatedResponse.prototype.getConversationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.SessionCreatedResponse} returns this
 */
proto.codingAssistant.SessionCreatedResponse.prototype.setConversationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool success = 3;
 * @return {boolean}
 */
proto.codingAssistant.SessionCreatedResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.codingAssistant.SessionCreatedResponse} returns this
 */
proto.codingAssistant.SessionCreatedResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string error = 4;
 * @return {string}
 */
proto.codingAssistant.SessionCreatedResponse.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.SessionCreatedResponse} returns this
 */
proto.codingAssistant.SessionCreatedResponse.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.codingAssistant.CloseSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.codingAssistant.CloseSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.codingAssistant.CloseSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.CloseSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.codingAssistant.CloseSessionRequest}
 */
proto.codingAssistant.CloseSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.codingAssistant.CloseSessionRequest;
  return proto.codingAssistant.CloseSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.codingAssistant.CloseSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.codingAssistant.CloseSessionRequest}
 */
proto.codingAssistant.CloseSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.codingAssistant.CloseSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.codingAssistant.CloseSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.codingAssistant.CloseSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.CloseSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.codingAssistant.CloseSessionRequest.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.CloseSessionRequest} returns this
 */
proto.codingAssistant.CloseSessionRequest.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.codingAssistant.SendMessageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.codingAssistant.SendMessageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.codingAssistant.SendMessageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.SendMessageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    currentCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    contextMap: (f = msg.getContextMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.codingAssistant.SendMessageRequest}
 */
proto.codingAssistant.SendMessageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.codingAssistant.SendMessageRequest;
  return proto.codingAssistant.SendMessageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.codingAssistant.SendMessageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.codingAssistant.SendMessageRequest}
 */
proto.codingAssistant.SendMessageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentCode(value);
      break;
    case 4:
      var value = msg.getContextMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.codingAssistant.SendMessageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.codingAssistant.SendMessageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.codingAssistant.SendMessageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.SendMessageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurrentCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContextMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.codingAssistant.SendMessageRequest.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.SendMessageRequest} returns this
 */
proto.codingAssistant.SendMessageRequest.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.codingAssistant.SendMessageRequest.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.SendMessageRequest} returns this
 */
proto.codingAssistant.SendMessageRequest.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string current_code = 3;
 * @return {string}
 */
proto.codingAssistant.SendMessageRequest.prototype.getCurrentCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.SendMessageRequest} returns this
 */
proto.codingAssistant.SendMessageRequest.prototype.setCurrentCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * map<string, string> context = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.codingAssistant.SendMessageRequest.prototype.getContextMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.codingAssistant.SendMessageRequest} returns this
 */
proto.codingAssistant.SendMessageRequest.prototype.clearContextMap = function() {
  this.getContextMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.codingAssistant.StreamChunkResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.codingAssistant.StreamChunkResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.codingAssistant.StreamChunkResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.StreamChunkResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    chunk: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.codingAssistant.StreamChunkResponse}
 */
proto.codingAssistant.StreamChunkResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.codingAssistant.StreamChunkResponse;
  return proto.codingAssistant.StreamChunkResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.codingAssistant.StreamChunkResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.codingAssistant.StreamChunkResponse}
 */
proto.codingAssistant.StreamChunkResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChunk(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.codingAssistant.StreamChunkResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.codingAssistant.StreamChunkResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.codingAssistant.StreamChunkResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.StreamChunkResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChunk();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.codingAssistant.StreamChunkResponse.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.StreamChunkResponse} returns this
 */
proto.codingAssistant.StreamChunkResponse.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string chunk = 2;
 * @return {string}
 */
proto.codingAssistant.StreamChunkResponse.prototype.getChunk = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.StreamChunkResponse} returns this
 */
proto.codingAssistant.StreamChunkResponse.prototype.setChunk = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.codingAssistant.StreamCompleteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.codingAssistant.StreamCompleteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.codingAssistant.StreamCompleteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.StreamCompleteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    suggestedCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
    validation: (f = msg.getValidation()) && proto.codingAssistant.ValidationResult.toObject(includeInstance, f),
    explanation: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.codingAssistant.StreamCompleteResponse}
 */
proto.codingAssistant.StreamCompleteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.codingAssistant.StreamCompleteResponse;
  return proto.codingAssistant.StreamCompleteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.codingAssistant.StreamCompleteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.codingAssistant.StreamCompleteResponse}
 */
proto.codingAssistant.StreamCompleteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuggestedCode(value);
      break;
    case 3:
      var value = new proto.codingAssistant.ValidationResult;
      reader.readMessage(value,proto.codingAssistant.ValidationResult.deserializeBinaryFromReader);
      msg.setValidation(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExplanation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.codingAssistant.StreamCompleteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.codingAssistant.StreamCompleteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.codingAssistant.StreamCompleteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.StreamCompleteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuggestedCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValidation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.codingAssistant.ValidationResult.serializeBinaryToWriter
    );
  }
  f = message.getExplanation();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.codingAssistant.StreamCompleteResponse.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.StreamCompleteResponse} returns this
 */
proto.codingAssistant.StreamCompleteResponse.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string suggested_code = 2;
 * @return {string}
 */
proto.codingAssistant.StreamCompleteResponse.prototype.getSuggestedCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.StreamCompleteResponse} returns this
 */
proto.codingAssistant.StreamCompleteResponse.prototype.setSuggestedCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ValidationResult validation = 3;
 * @return {?proto.codingAssistant.ValidationResult}
 */
proto.codingAssistant.StreamCompleteResponse.prototype.getValidation = function() {
  return /** @type{?proto.codingAssistant.ValidationResult} */ (
    jspb.Message.getWrapperField(this, proto.codingAssistant.ValidationResult, 3));
};


/**
 * @param {?proto.codingAssistant.ValidationResult|undefined} value
 * @return {!proto.codingAssistant.StreamCompleteResponse} returns this
*/
proto.codingAssistant.StreamCompleteResponse.prototype.setValidation = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.codingAssistant.StreamCompleteResponse} returns this
 */
proto.codingAssistant.StreamCompleteResponse.prototype.clearValidation = function() {
  return this.setValidation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.codingAssistant.StreamCompleteResponse.prototype.hasValidation = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string explanation = 4;
 * @return {string}
 */
proto.codingAssistant.StreamCompleteResponse.prototype.getExplanation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.StreamCompleteResponse} returns this
 */
proto.codingAssistant.StreamCompleteResponse.prototype.setExplanation = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.codingAssistant.ErrorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.codingAssistant.ErrorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.codingAssistant.ErrorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ErrorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    error: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.codingAssistant.ErrorResponse}
 */
proto.codingAssistant.ErrorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.codingAssistant.ErrorResponse;
  return proto.codingAssistant.ErrorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.codingAssistant.ErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.codingAssistant.ErrorResponse}
 */
proto.codingAssistant.ErrorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.codingAssistant.ErrorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.codingAssistant.ErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.codingAssistant.ErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ErrorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.codingAssistant.ErrorResponse.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.ErrorResponse} returns this
 */
proto.codingAssistant.ErrorResponse.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string error = 2;
 * @return {string}
 */
proto.codingAssistant.ErrorResponse.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.ErrorResponse} returns this
 */
proto.codingAssistant.ErrorResponse.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.codingAssistant.ValidationResult.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.codingAssistant.ValidationResult.prototype.toObject = function(opt_includeInstance) {
  return proto.codingAssistant.ValidationResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.codingAssistant.ValidationResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ValidationResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    valid: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    errorsList: jspb.Message.toObjectList(msg.getErrorsList(),
    proto.codingAssistant.ValidationError.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.codingAssistant.ValidationResult}
 */
proto.codingAssistant.ValidationResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.codingAssistant.ValidationResult;
  return proto.codingAssistant.ValidationResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.codingAssistant.ValidationResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.codingAssistant.ValidationResult}
 */
proto.codingAssistant.ValidationResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValid(value);
      break;
    case 2:
      var value = new proto.codingAssistant.ValidationError;
      reader.readMessage(value,proto.codingAssistant.ValidationError.deserializeBinaryFromReader);
      msg.addErrors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.codingAssistant.ValidationResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.codingAssistant.ValidationResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.codingAssistant.ValidationResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ValidationResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValid();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getErrorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.codingAssistant.ValidationError.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool valid = 1;
 * @return {boolean}
 */
proto.codingAssistant.ValidationResult.prototype.getValid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.codingAssistant.ValidationResult} returns this
 */
proto.codingAssistant.ValidationResult.prototype.setValid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated ValidationError errors = 2;
 * @return {!Array<!proto.codingAssistant.ValidationError>}
 */
proto.codingAssistant.ValidationResult.prototype.getErrorsList = function() {
  return /** @type{!Array<!proto.codingAssistant.ValidationError>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.codingAssistant.ValidationError, 2));
};


/**
 * @param {!Array<!proto.codingAssistant.ValidationError>} value
 * @return {!proto.codingAssistant.ValidationResult} returns this
*/
proto.codingAssistant.ValidationResult.prototype.setErrorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.codingAssistant.ValidationError=} opt_value
 * @param {number=} opt_index
 * @return {!proto.codingAssistant.ValidationError}
 */
proto.codingAssistant.ValidationResult.prototype.addErrors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.codingAssistant.ValidationError, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.codingAssistant.ValidationResult} returns this
 */
proto.codingAssistant.ValidationResult.prototype.clearErrorsList = function() {
  return this.setErrorsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.codingAssistant.ValidationError.prototype.toObject = function(opt_includeInstance) {
  return proto.codingAssistant.ValidationError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.codingAssistant.ValidationError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ValidationError.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    line: jspb.Message.getFieldWithDefault(msg, 2, 0),
    column: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.codingAssistant.ValidationError}
 */
proto.codingAssistant.ValidationError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.codingAssistant.ValidationError;
  return proto.codingAssistant.ValidationError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.codingAssistant.ValidationError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.codingAssistant.ValidationError}
 */
proto.codingAssistant.ValidationError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLine(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setColumn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.codingAssistant.ValidationError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.codingAssistant.ValidationError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.codingAssistant.ValidationError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ValidationError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLine();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getColumn();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.codingAssistant.ValidationError.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.ValidationError} returns this
 */
proto.codingAssistant.ValidationError.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 line = 2;
 * @return {number}
 */
proto.codingAssistant.ValidationError.prototype.getLine = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.codingAssistant.ValidationError} returns this
 */
proto.codingAssistant.ValidationError.prototype.setLine = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 column = 3;
 * @return {number}
 */
proto.codingAssistant.ValidationError.prototype.getColumn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.codingAssistant.ValidationError} returns this
 */
proto.codingAssistant.ValidationError.prototype.setColumn = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.codingAssistant.ListConversationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.codingAssistant.ListConversationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.codingAssistant.ListConversationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ListConversationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contextType: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.codingAssistant.ListConversationsRequest}
 */
proto.codingAssistant.ListConversationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.codingAssistant.ListConversationsRequest;
  return proto.codingAssistant.ListConversationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.codingAssistant.ListConversationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.codingAssistant.ListConversationsRequest}
 */
proto.codingAssistant.ListConversationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContextType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.codingAssistant.ListConversationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.codingAssistant.ListConversationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.codingAssistant.ListConversationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ListConversationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContextType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.codingAssistant.ListConversationsRequest.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.ListConversationsRequest} returns this
 */
proto.codingAssistant.ListConversationsRequest.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.codingAssistant.ListConversationsRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.ListConversationsRequest} returns this
 */
proto.codingAssistant.ListConversationsRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string context_type = 3;
 * @return {string}
 */
proto.codingAssistant.ListConversationsRequest.prototype.getContextType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.ListConversationsRequest} returns this
 */
proto.codingAssistant.ListConversationsRequest.prototype.setContextType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.codingAssistant.ConversationListResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.codingAssistant.ConversationListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.codingAssistant.ConversationListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.codingAssistant.ConversationListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ConversationListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    conversationsList: jspb.Message.toObjectList(msg.getConversationsList(),
    proto.codingAssistant.ConversationInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.codingAssistant.ConversationListResponse}
 */
proto.codingAssistant.ConversationListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.codingAssistant.ConversationListResponse;
  return proto.codingAssistant.ConversationListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.codingAssistant.ConversationListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.codingAssistant.ConversationListResponse}
 */
proto.codingAssistant.ConversationListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 2:
      var value = new proto.codingAssistant.ConversationInfo;
      reader.readMessage(value,proto.codingAssistant.ConversationInfo.deserializeBinaryFromReader);
      msg.addConversations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.codingAssistant.ConversationListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.codingAssistant.ConversationListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.codingAssistant.ConversationListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ConversationListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConversationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.codingAssistant.ConversationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.codingAssistant.ConversationListResponse.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.ConversationListResponse} returns this
 */
proto.codingAssistant.ConversationListResponse.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ConversationInfo conversations = 2;
 * @return {!Array<!proto.codingAssistant.ConversationInfo>}
 */
proto.codingAssistant.ConversationListResponse.prototype.getConversationsList = function() {
  return /** @type{!Array<!proto.codingAssistant.ConversationInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.codingAssistant.ConversationInfo, 2));
};


/**
 * @param {!Array<!proto.codingAssistant.ConversationInfo>} value
 * @return {!proto.codingAssistant.ConversationListResponse} returns this
*/
proto.codingAssistant.ConversationListResponse.prototype.setConversationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.codingAssistant.ConversationInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.codingAssistant.ConversationInfo}
 */
proto.codingAssistant.ConversationListResponse.prototype.addConversations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.codingAssistant.ConversationInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.codingAssistant.ConversationListResponse} returns this
 */
proto.codingAssistant.ConversationListResponse.prototype.clearConversationsList = function() {
  return this.setConversationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.codingAssistant.ConversationInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.codingAssistant.ConversationInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.codingAssistant.ConversationInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ConversationInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contextType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    createdAtMs: jspb.Message.getFieldWithDefault(msg, 4, 0),
    updatedAtMs: jspb.Message.getFieldWithDefault(msg, 5, 0),
    messageCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    lastMessagePreview: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.codingAssistant.ConversationInfo}
 */
proto.codingAssistant.ConversationInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.codingAssistant.ConversationInfo;
  return proto.codingAssistant.ConversationInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.codingAssistant.ConversationInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.codingAssistant.ConversationInfo}
 */
proto.codingAssistant.ConversationInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContextType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAtMs(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAtMs(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMessageCount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastMessagePreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.codingAssistant.ConversationInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.codingAssistant.ConversationInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.codingAssistant.ConversationInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.ConversationInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContextType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCreatedAtMs();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUpdatedAtMs();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getMessageCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getLastMessagePreview();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.codingAssistant.ConversationInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.ConversationInfo} returns this
 */
proto.codingAssistant.ConversationInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.codingAssistant.ConversationInfo.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.ConversationInfo} returns this
 */
proto.codingAssistant.ConversationInfo.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string context_type = 3;
 * @return {string}
 */
proto.codingAssistant.ConversationInfo.prototype.getContextType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.ConversationInfo} returns this
 */
proto.codingAssistant.ConversationInfo.prototype.setContextType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 created_at_ms = 4;
 * @return {number}
 */
proto.codingAssistant.ConversationInfo.prototype.getCreatedAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.codingAssistant.ConversationInfo} returns this
 */
proto.codingAssistant.ConversationInfo.prototype.setCreatedAtMs = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 updated_at_ms = 5;
 * @return {number}
 */
proto.codingAssistant.ConversationInfo.prototype.getUpdatedAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.codingAssistant.ConversationInfo} returns this
 */
proto.codingAssistant.ConversationInfo.prototype.setUpdatedAtMs = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 message_count = 6;
 * @return {number}
 */
proto.codingAssistant.ConversationInfo.prototype.getMessageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.codingAssistant.ConversationInfo} returns this
 */
proto.codingAssistant.ConversationInfo.prototype.setMessageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string last_message_preview = 7;
 * @return {string}
 */
proto.codingAssistant.ConversationInfo.prototype.getLastMessagePreview = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.ConversationInfo} returns this
 */
proto.codingAssistant.ConversationInfo.prototype.setLastMessagePreview = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.codingAssistant.DeleteConversationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.codingAssistant.DeleteConversationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.codingAssistant.DeleteConversationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.DeleteConversationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    conversationId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.codingAssistant.DeleteConversationRequest}
 */
proto.codingAssistant.DeleteConversationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.codingAssistant.DeleteConversationRequest;
  return proto.codingAssistant.DeleteConversationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.codingAssistant.DeleteConversationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.codingAssistant.DeleteConversationRequest}
 */
proto.codingAssistant.DeleteConversationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConversationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.codingAssistant.DeleteConversationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.codingAssistant.DeleteConversationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.codingAssistant.DeleteConversationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.codingAssistant.DeleteConversationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConversationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.codingAssistant.DeleteConversationRequest.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.DeleteConversationRequest} returns this
 */
proto.codingAssistant.DeleteConversationRequest.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string conversation_id = 2;
 * @return {string}
 */
proto.codingAssistant.DeleteConversationRequest.prototype.getConversationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.codingAssistant.DeleteConversationRequest} returns this
 */
proto.codingAssistant.DeleteConversationRequest.prototype.setConversationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.codingAssistant);
